
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import ProblemPassageContent from '@/components/organisms/ProblemPassageContent.vue'
import LearningProgressTip from '@/components/organisms/LearningProgressTip.vue'
import { LearningProblemCurriculumUnit } from '@/models/LearningProblemCurriculumUnit'
import { LearningProgress } from '@/const/LearningProgress'

/**
 * 単元別問題選択 次の演習問題
 */
@Component({
  components: {
    ImageBase,
    ProblemPassageContent,
    LearningProgressTip,
  },
})
export default class ProblemPassageNext extends Vue {
  /** 問題情報 */
  @Prop()
  private problemNext!: LearningProblemCurriculumUnit.Next

  /** 線の有無 */
  @Prop()
  private showLine!: boolean

  /** 次の演習問題クリック時のイベント */
  @Prop()
  private eventClickNextProblem!: () => Promise<void>

  /**
   * 問題のレベル
   *
   * @returns 学習進捗マスター
   */
  private get problemLevel(): LearningProgress.LearningProgressMaster {
    return this.problemNext.learningProgress
  }

  /**
   * 学習完了か否か
   *
   * @returns 学習完了ならtrue
   */
  private get isCompleted(): boolean {
    return this.problemNext.learningProgress === LearningProgress.COMPLETE
  }
}
